import CreateSetupBackend from "../config/config.js";
import utilService from "./utilService.js";
import { isMutual } from "../../utils/isMutual.jsx";

let SetupBackend = null;

function extractPayload(response) {
  return response?.data?.body || response?.data?.data || response?.data || {};
}

function login(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/login", data);
}

async function resetCode(data) {
  await utilService.getJWT();
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/resetcode", data);
}

function resetPassword(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/resetpassword", data);
}

function destroyContact(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/destroycontact", data);
}

function destroyContactPixKey(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/destroycontactpixkey", data);
}

function updatePin(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/updatePin", data);
}

function verifyPin(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/verifypin", data);
}

function createContact(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/createContact", data);
}

function indexContacts() {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/indexcontacts?userEmail=${sessionStorage.getItem(
      "emailUser",
    )}`,
  );
}

function createContactPixKey(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/v1/accountmanager/createcontactpixkey/${data.contactId}`,
    data.body,
  );
}

function externalKyc(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/externalkyc", data);
}

function showBalance() {
  SetupBackend = CreateSetupBackend();
  if (isMutual()) {
    return SetupBackend.get(
      `/v1/baas/accounts/balance?email=${sessionStorage.getItem("emailUser")}`,
    ).then((res) => {
      const payload = extractPayload(res);
      const amount =
        payload?.amount ??
        payload?.balance ??
        res?.data?.body?.amount ??
        res?.data?.data?.amount ??
        res?.data?.balance ??
        res?.data?.amount ??
        payload?.availableBalance ??
        0;

      const account =
        payload?.account ||
        payload?.accountNumber ||
        payload?.bankAccount ||
        "";
      const agency =
        payload?.agency || payload?.branch || payload?.branchNumber || "";

      return {
        ...res,
        data: {
          ...(res?.data || {}),
          account,
          agency,
          body: {
            ...((res?.data && res.data.body) || {}),
            amount,
            account,
            agency,
          },
        },
      };
    });
  }

  return SetupBackend.get(
    `/v1/accountmanager/showbalance?Account=${sessionStorage.getItem(
      "account",
    )}&email=${sessionStorage.getItem("emailUser")}`,
  );
}

function showMovement(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/showmovement?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}&DateFrom=${
      data.dateFrom
    }&DateTo=${data.dateTo}&Page=${data.page}`,
  );
}

function showDownload(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/downloadmovement?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}&DateFrom=${
      data.dateFrom
    }&DateTo=${data.dateTo}`,
  );
}

function showAccountStatus(data) {
  SetupBackend = CreateSetupBackend();
  // Usar novo endpoint para todos os casos
  const email = data?.email || sessionStorage.getItem("emailUser");
  return SetupBackend.get(`/v1/baas/accounts/details?email=${email}`).then(
    (res) => {
      const raw = res?.data?.body || res?.data?.data || res?.data || {};
      const account =
        raw?.account ||
        raw?.accountData ||
        raw?.bankAccountData ||
        raw?.wallet ||
        {};

      const normalizedAccount = {
        account:
          account?.account ||
          account?.accountNumber ||
          raw?.accountNumber ||
          raw?.accountId ||
          "",
        branch:
          account?.branch ||
          account?.branchNumber ||
          raw?.branch ||
          raw?.branchNumber ||
          "",
        name:
          account?.name || raw?.name || raw?.fullName || raw?.ownerName || "",
        documentNumber:
          account?.documentNumber ||
          raw?.documentNumber ||
          raw?.document?.number ||
          raw?.taxId ||
          "",
      };

      return {
        ...res,
        data: {
          ...(res?.data || {}),
          body: {
            ...((res?.data && res.data.body) || {}),
            account: normalizedAccount,
          },
        },
      };
    },
  );
}

function showAccountPF() {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/showaccountpf?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}`,
  );
}

function showAccountPJ() {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/showaccountpj?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}`,
  );
}

function indexAccountsPF(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/indexaccountspf?DateFrom=${data.dateFrom}&DateTo=${data.dateTo}&Limit=${data.limit}&Page=${data.page}`,
  );
}

function indexAccountsPJ(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/indexaccountspj?DateFrom=${data.dateFrom}&DateTo=${data.dateTo}&Limit=${data.limit}&Page=${data.page}`,
  );
}

function createAccountPJ(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/createaccount", data);
}

function createAccountPF(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/createaccountpf", data);
}

function updateAccountPF(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.put(
    `/v1/accountmanager/updateaccountpf?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}`,
    data,
  );
}

function updateAccountPJ(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.put(
    `/v1/accountmanager/updateaccountpj?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}`,
    data,
  );
}

function deactivateAccount(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.put(
    `/v1/accountmanager/deactivateaccount?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}`,
    data,
  );
}

function destroyAccount(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.delete(
    `/v1/accountmanager/destroyaccount?Account=${sessionStorage.getItem(
      "account",
    )}&DocumentNumber=${sessionStorage.getItem("doc")}&reason=${data.reason}`,
  );
}

function showStatement(data) {
  SetupBackend = CreateSetupBackend();

  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");

    const buildUrl = (endDateOverride) => {
      let url = `/v1/baas/accounts/statements?email=${email}`;
      const endDate = endDateOverride || data?.endDate;

      if (data?.startDate) {
        url += `&startDate=${encodeURIComponent(data.startDate)}`;
      }
      if (endDate) {
        url += `&endDate=${encodeURIComponent(endDate)}`;
      }
      if (typeof data?.limit !== "undefined") {
        url += `&limit=${data.limit}`;
      }
      if (typeof data?.offset !== "undefined") {
        url += `&offset=${data.offset}`;
      }
      if (data?.currency) {
        url += `&currency=${data.currency}`;
      }
      if (data?.sort) {
        url += `&sort=${data.sort}`;
      }
      if (data?.operationType) {
        url += `&operationType=${encodeURIComponent(data.operationType)}`;
      }

      return url;
    };

    const toCents = (value) => {
      const parsed = Number(value ?? 0);
      if (Number.isNaN(parsed)) {
        return 0;
      }
      return Math.round(parsed * 100);
    };

    const normalizeStatementItem = (item) => {
      const amountCents = toCents(item?.amount);
      const balanceCents = toCents(item?.balance);
      const normalizedOperationType = (item?.operationType || "")
        .toString()
        .toUpperCase();
      const normalizedDescription = (item?.description || "")
        .toString()
        .trim()
        .toLowerCase();
      const isRefund =
        normalizedOperationType === "PAYIN_REFUND" ||
        normalizedOperationType === "PAYIN" &&
          (normalizedDescription.includes("wallet transfer reversal") ||
            normalizedDescription.startsWith("refund"));
      const isDebit =
        normalizedOperationType === "PAYOUT"
          ? true
          : normalizedOperationType === "PAYIN"
            ? false
            : amountCents < 0;
      const counterpartyDocument = item?.counterparty?.document?.number || "";
      const counterpartyName = item?.counterparty?.name || "";
      const metadata =
        [counterpartyName, counterpartyDocument].filter(Boolean).join(" ") ||
        null;

      return {
        id: item?.transactionId || item?.orderId || item?.externalCode || "",
        amount: amountCents,
        amount_cents: String(amountCents),
        balance: balanceCents,
        balance_cents: String(balanceCents),
        type: isRefund ? "REFUND" : isDebit ? "DEBIT" : "CREDIT",
        status: item?.status || (isRefund ? "Devolução" : isDebit ? "Emitido" : "Recebido"),
        description: item?.description || item?.operationType || "Movimentação",
        transaction_type:
          (item?.operationType || "").toUpperCase() === "PIX" ? "PIX" : "misc",
        entry_date: item?.transactionDate || null,
        reference: item?.transactionId || item?.orderId || null,
        reference_type: item?.operationType || "PIX",
        operation_type: normalizedOperationType || null,
        metadata,
        payer_name: counterpartyName || null,
        customer_name: counterpartyName || null,
        customer_ref: counterpartyDocument || null,
        counterparty: item?.counterparty || null,
        end_to_end_id: item?.endToEndId || null,
        external_code: item?.externalCode || null,
        // A devolução é feita contra a ordem original, não contra a transação:
        // sem o orderId o lançamento recebido não tem como ser estornado.
        order_id: item?.orderId || null,
        refund_id: item?.refundId || null,
        refund_end_to_end_id: item?.refundEndToEndId || null,
        payment_method: item?.paymentMethod || null,
      };
    };

    const extractRawList = (res) => {
      const rawList =
        res?.data?.data ||
        res?.data?.items ||
        res?.data?.results ||
        res?.data?.body?.data ||
        res?.data?.body?.items ||
        res?.data?.body?.results ||
        res?.data?.body?.statements ||
        res?.data?.body?.movements ||
        res?.data?.statements ||
        res?.data?.movements ||
        [];

      return Array.isArray(rawList) ? rawList : [];
    };

    // A Gowd devolve o extrato paginado: cada resposta traz no máximo uma página
    // e sinaliza a continuação com hasNext/nextCursor. Ler só a primeira resposta
    // mostrava um extrato truncado, sem nenhum aviso na tela. Como a ordenação é
    // do mais recente para o mais antigo, a página seguinte é a mesma consulta
    // com o nextCursor no endDate.
    const readHasNext = (res) =>
      res?.data?.hasNext ?? res?.data?.body?.hasNext ?? false;
    const readNextCursor = (res) =>
      res?.data?.nextCursor ?? res?.data?.body?.nextCursor ?? null;

    const itemKey = (item) =>
      item?.transactionId ||
      item?.orderId ||
      item?.endToEndId ||
      item?.externalCode ||
      null;

    // Teto de segurança: a tela nunca fica consultando indefinidamente, mesmo se
    // a API insistir em sinalizar continuação.
    const MAX_PAGES = 40;

    const collectAllPages = async () => {
      const collected = [];
      const seen = new Set();
      let res = await SetupBackend.get(buildUrl());
      const firstResponse = res;
      let pages = 0;

      for (;;) {
        let added = 0;

        extractRawList(res).forEach((item) => {
          const key = itemKey(item);
          if (key) {
            if (seen.has(key)) {
              return;
            }
            seen.add(key);
          }
          collected.push(item);
          added += 1;
        });

        pages += 1;

        const nextCursor = readNextCursor(res);

        if (
          !readHasNext(res) ||
          !nextCursor ||
          pages >= MAX_PAGES ||
          (pages > 1 && added === 0)
        ) {
          break;
        }

        res = await SetupBackend.get(buildUrl(nextCursor));
      }

      return { firstResponse, collected };
    };

    return collectAllPages().then(({ firstResponse: res, collected }) => {
      const list = collected.map((item) => normalizeStatementItem(item));

      const total = list.length;

      const limit =
        res?.data?.meta?.limit ??
        res?.data?.body?.meta?.limit ??
        data?.limit ??
        100;

      return {
        ...res,
        data: {
          ...(res?.data || {}),
          data: list,
          meta: {
            ...((res?.data && res.data.meta) || {}),
            total,
            limit,
          },
        },
      };
    });
  }

  return SetupBackend.get(
    `/v1/accountmanager/showstatements?email=${sessionStorage.getItem(
      "emailUser",
    )}&startDate=${data.startDate}&endDate=${data.endDate}&limit=${
      data.limit
    }&offset=${data.offset}&filter=${data.filter}`,
  );
}

function search(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/search?email=${sessionStorage.getItem(
      "emailUser",
    )}&endtoend=${data}`,
  );
}

function showStatementMt(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/mtstatements?email=${sessionStorage.getItem(
      "emailUser",
    )}&startDate=${data.startDate}&endDate=${data.endDate}&pageLimit=${
      data.limit
    }&pageOffset=${data.offset}&endtoendid=${data.endtoendid}`,
  );
}

function downloadStatement(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/accountmanager/downloadstatements?startDate=${
      data.startDate
    }&endDate=${data.endDate}&doc=${sessionStorage.getItem("doc")}`,
    {
      responseType: "blob",
      timeout: 0,
    },
  );
}

function createMFA(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/createmfa", data);
}

function verifyMFA(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/verifymfa", data);
}

function changePasswordWith2FA(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/change-password-2fa", data);
}

function validateRegister(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/accountmanager/validateregister", data);
}

const backendServices = {
  externalKyc,
  showBalance,
  showMovement,
  showAccountStatus,
  showAccountPF,
  showAccountPJ,
  indexAccountsPF,
  indexAccountsPJ,
  createAccountPJ,
  createAccountPF,
  updateAccountPF,
  updateAccountPJ,
  deactivateAccount,
  destroyAccount,
  login,
  verifyPin,
  createContact,
  indexContacts,
  createContactPixKey,
  resetCode,
  resetPassword,
  destroyContact,
  destroyContactPixKey,
  updatePin,
  showDownload,
  showStatement,
  downloadStatement,
  showStatementMt,
  createMFA,
  verifyMFA,
  changePasswordWith2FA,
  validateRegister,
  search,
};

export default backendServices;
